import axios from '../axios';

/**
 * Cart API - כל הפונקציות הקשורות לעגלת קניות
 */

export const cartApi = {
  // קבלת תוכן העגלה
  getCartItems: async () => {
    try {
      const response = await axios.get('/cart');
      return response.data;
    } catch (error) {
      console.error('Error fetching cart items:', error);
      throw error;
    }
  },

  // הוספת מוצר לעגלה
  addToCart: async (productId, quantity = 1) => {
    try {
      const response = await axios.post('/cart', { productId, quantity });
      return response.data;
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  },

  // הסרת מוצר מהעגלה
  removeFromCart: async (productId) => {
    try {
      const response = await axios.delete(`/cart/item`, { data: { productId } });
      return response.data;
    } catch (error) {
      console.error('Error removing from cart:', error);
      throw error;
    }
  },

  // עדכון כמות מוצר בעגלה
  updateQuantity: async (productId, quantity) => {
    try {
      const response = await axios.put(`/cart/${productId}`, { quantity });
      return response.data;
    } catch (error) {
      console.error('Error updating cart quantity:', error);
      throw error;
    }
  },

  // ניקוי העגלה
  clearCart: async () => {
    try {
      const response = await axios.delete('/cart');
      return response.data;
    } catch (error) {
      console.error('Error clearing cart:', error);
      throw error;
    }
  }
};

export default cartApi; 